import dynamic from "next/dynamic";

import type { Props as TrendingNavBarProps } from "scmp-app/components/trending-nav-bar";

export const DynamicHomeNewsTicker = dynamic<Record<string, never>>(() =>
  import("scmp-app/components/home/news-ticker").then(module => module.HomeNewsTicker),
);

export const DynamicTrendingNavBar = dynamic<TrendingNavBarProps>(() =>
  import("scmp-app/components/trending-nav-bar").then(module => module.TrendingNavBar),
);
